import React from "react";
import { motion } from "framer-motion";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import logo from "../../assets/images/luxury-tours-luxury-transfers-black-leader-athens.png";
import paymentImage from "../../assets/images/PAYMENTS-BOTTOM-4.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-t from-black via-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Decorative blurred blobs */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-gray-700/30 rounded-full blur-3xl z-0" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gray-600/20 rounded-full blur-3xl z-0" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Logo */}
        <motion.img
          src={logo}
          alt="Black Leader Athens logo"
          className="h-24 pt-8 object-contain mx-auto"
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.3 }}
        />

        <div className="flex md:flex-row flex-col justify-around gap-10 pt-12 text-center md:text-left sm:m-0 mx-auto sm:items-baseline items-center content-center">
          {/* About Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="w-full md:w-1/3"
          >
            <h2 className="text-xl font-bold mb-4 tracking-wide">About Black Leader</h2>
            <motion.hr
              className="w-full h-1 md:w-16 md:h-1 bg-gray-700 mb-4 border-0 rounded"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            />
            <p className="text-gray-400 mb-4 leading-relaxed">
              <span className="font-semibold text-white">Black Leader Athens</span> delivers exclusive private transfers and luxury sightseeing tours across Athens and Greece. Travel in style with our professional English-speaking chauffeurs and our fleet of Mercedes E-Class taxis, VIP mini vans, and mini buses for up to 20 passengers.
              <br /><br />
              <span className="text-gray-300">Business or leisure, day or night,</span> we guarantee safe, punctual, and comfortable journeys-24/7, all year round.
            </p>
            {/* Social Links */}
            {/* <div className="flex justify-center md:justify-start space-x-4 mt-4">
              <motion.a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
                aria-label="Facebook"
              >
                <FaFacebookF />
              </motion.a>
              <motion.a
                href="https://twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
                aria-label="Twitter"
              >
                <FaTwitter />
              </motion.a>
              <motion.a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
                aria-label="Instagram"
              >
                <FaInstagram />
              </motion.a>
              <motion.a
                href="https://linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </motion.a>
            </div> */}
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="w-full md:w-1/3"
          >
            <h2 className="text-xl font-bold mb-4 tracking-wide">Contact Us</h2>
            <motion.hr
              className="w-full h-1 md:w-16 md:h-1 bg-gray-700 mb-4 border-0 rounded"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            />
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-center justify-center md:justify-start">
                <FaPhoneAlt className="text-gray-300 mr-3" />
                <a
                  href="tel:+306932214626"
                  className="hover:text-white transition-colors duration-300"
                >
                  +30 693 2214626
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <FaEnvelope className="text-gray-300 mr-3" />
                <a
                  href="mailto:blackleaderathens@gmail.com"
                  className="hover:text-white transition-colors duration-300"
                >
                  blackleaderathens@gmail.com
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <FaMapMarkerAlt className="text-gray-300 mr-3" />
                <span>
                  Athens, Greece
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Payment Methods */}
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="w-full md:w-1/3 flex flex-col items-center"
          >
            <h2 className="text-xl font-bold mb-4 tracking-wide">Pay On Board</h2>
            <motion.hr
              className="w-full h-1 md:w-16 md:h-1 bg-gray-700 mb-4 border-0 rounded"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            />
            <div className="flex justify-center">
              <motion.img
                src={paymentImage}
                alt="Accepted payment methods"
                className="h-16 object-contain"
                whileHover={{ scale: 1.08 }}
                transition={{ duration: 0.3 }}
              />
            </div>
            <span className="text-gray-400 text-xs mt-2">
              All major cards accepted
            </span>
          </motion.div> */}
        </div>
      </div>

      {/* Divider */}
      <motion.div
        className="w-full h-px bg-gray-700 mt-12"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      />

      {/* Copyright */}
      <motion.div
        className="py-6 text-center text-gray-400 text-sm relative z-10"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        Black Leader Athens Transfer © {currentYear} &mdash; Powered and created by{" "}
        <motion.a
          href="https://create-website.gr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-300 font-semibold transition-colors duration-300"
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.2 }}
        >
          CREATE-WEBSITE.GR
        </motion.a>
      </motion.div>
    </footer>
  );
};

export default Footer;
